<template>
  <div>
    <table border="1" class="table" bordercolor="#ebeef4">
      <tr style="background:#F3E8E3">
        <th>编号</th>
        <th>项目</th>
        <th>记账月份</th>
        <th>实际消耗月份</th>
        <th>达人账号</th>
        <th>上线时间</th>
        <th v-if="!isHiddenHZXS">合作形式</th>
        <th>实际消耗</th>
        <th v-if="dataInfo.account.is_discount==1">折扣率(小数)</th>
        <th v-if="dataInfo.account.is_discount==1">折扣金额</th>
        <th>流量助推</th>
        <th>链接费</th>
        <th>置顶费</th>
        <th>价格合计</th>
      </tr>
      <template v-for="(items,ind) in dataInfo.order.list">
        <tr v-for="(item,index) in items.row" :key="ind+'tr'+index+'row'">
          <td>{{index+1}}</td>
          <td>{{item.proejct_name}}</td>
          <td>{{item.month}}</td>
          <td>{{item.order_original_month}}</td>
          <td>{{item.internet_celebrity_name}}</td>
          <td>{{item.uptime}}</td>
          <td v-if="!isHiddenHZXS">{{item.form_of_cooperation}}</td>
          <td style="text-align: right;">{{$formatNum(item.actual_consumption)}}</td>
          <td v-if="dataInfo.account.is_discount==1">{{item.discount_rate}}</td>
          <td v-if="dataInfo.account.is_discount==1" style="text-align: right;">{{$formatNum(item.discount_amount)}}</td>
          <td style="text-align: right;">{{$formatNum(item.flow_boost_back_point)}}</td>
          <td style="text-align: right;">{{$formatNum(item.link_fee)}}</td>
          <td style="text-align: right;">{{$formatNum(item.top_fee)}}</td>
          <td style="text-align: right;">{{$formatNum(item.total_amount)}}</td>
        </tr>
        <tr style="background:#f4f7fa" :key="ind+'tr1'">
          <td :colspan="isHiddenHZXS ? '6' : '7'">{{items.sort_month}}小计</td>
          <td style="text-align: right;">{{$formatNum(items.actual_consumption)}}</td>
          <td v-if="dataInfo.account.is_discount==1"></td>
          <td v-if="dataInfo.account.is_discount==1" style="text-align: right;">{{$formatNum(items.discount_amount)}}</td>
          <td style="text-align: right;">{{$formatNum(items.flow_boost_back_point)}}</td>
          <td style="text-align: right;">{{$formatNum(items.link_fee)}}</td>
          <td style="text-align: right;">{{$formatNum(items.top_fee)}}</td>
          <td style="text-align: right;">{{$formatNum(items.total_amount)}}</td>
        </tr>
        <tr v-if="ind + 1 == dataInfo.order.list.length" :key="ind+'tr2'">
          <td :colspan="isHiddenHZXS ? '6' : '7'" style="color:#393d64;font-weight:500;">总金额</td>
          <td style="text-align: right;">{{$formatNum(dataInfo.order.total.actual_consumption)}}</td>
          <td v-if="dataInfo.account.is_discount==1"></td>
          <td v-if="dataInfo.account.is_discount==1" style="text-align: right;">{{$formatNum(dataInfo.order.total.discount_amount)}}</td>
          <td style="text-align: right;">{{$formatNum(dataInfo.order.total.flow_boost_back_point)}}</td>
          <td style="text-align: right;">{{$formatNum(dataInfo.order.total.link_fee)}}</td>
          <td style="text-align: right;">{{$formatNum(dataInfo.order.total.top_fee)}}</td>
          <td style="text-align: right;">{{$formatNum(dataInfo.order.total.total_amount)}}</td>
        </tr>
      </template>
    </table>
  </div>
</template>
<script>
export default {
  props: ['dataInfo'],
  data () {
    return {
    }
  },
  computed: {
    isHiddenHZXS() { // 甲方为"石家庄以岭药业股份有限公司"时，不要导出"合作形式"这列内容
      return this.dataInfo && this.dataInfo.account && 
        (this.dataInfo.account.party_a_name === '石家庄以岭药业股份有限公司' || 
         this.dataInfo.account.party_a_name === '广州孚马迪科技有限公司')
    },
  },
  created () {
  },
  methods: {
  }
}
</script>
<style lang="scss" scoped>
@import "../statementTemplate/statementDetail.scss";
</style>
<style lang="scss">
.statementToast {
  .el-form-item__content {
    font-size: 12px !important;
  }
  .el-form-item--mini.el-form-item {
    margin-bottom: 0 !important;
  }
  .table .el-input__inner {
    padding: 0 !important;
    text-align: center !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/newBilling/examine/gameStatement.vue